import React from "react";
import { Card } from "react-bootstrap";
import STRINGS from "../Constants/Strings";

const menuItems = [
  {
    key: "dashboard",
    icon: "fas fa-desktop",
    label: STRINGS.BRANCH.SIDEBARMENU.DASHBOARD_LABEL,
    disabled: false,
  },
  {
    key: "members",
    icon: "fas fa-users",
    label: STRINGS.BRANCH.SIDEBARMENU.MEMBERS_LABEL,
    disabled: false,
  },
  {
    key: "calendar",
    icon: "fas fa-calendar-day",
    label: STRINGS.BRANCH.SIDEBARMENU.CALENDAR_LABEL,
    disabled: true,
  },
  {
    key: "campaigns",
    icon: "fas fa-bullhorn",
    label: STRINGS.BRANCH.SIDEBARMENU.CAMPAIGNS_LABEL,
    disabled: true,
  },
  {
    key: "news",
    icon: "fas fa-rss",
    label: STRINGS.BRANCH.SIDEBARMENU.NEWS_LABEL,
    disabled: true,
  },
  {
    key: "reports",
    icon: "fas fa-chart-area",
    label: STRINGS.BRANCH.SIDEBARMENU.REPORTS_LABEL,
    disabled: true,
  },
  {
    key: "help",
    icon: "fas fa-question-circle",
    label: STRINGS.BRANCH.SIDEBARMENU.HELP_LABEL,
    disabled: true,
  },
];

export default function SidebarMenu({ activeMenu, onMenuClick }) {
  return (
    <form className="[ branch-menu-container ]">
      {menuItems.map((item, idx) => (
        <Card
          key={item.key}
          variant="outlined"
          className={
            "branch-menu-card main" +
            (activeMenu === item.key ? " active" : " inactive") +
            (idx === 0 ? " first" : "") +
            (idx === menuItems.length - 1 ? " last" : "")
          }
          onClick={() => {
            if (activeMenu !== item.key && !item.disabled) {
              if (item.key === "members") {
                // Send default tab config
                onMenuClick("members", {
                  primaryTab: "personal",
                  secondaryTab: "members",
                });
              } else {
                onMenuClick(item.key);
              }
            }
          }}
          style={{
            cursor: activeMenu === item.key ? "auto" : "pointer",
          }}
        >
          <Card.Body>
            <i className={`[ ${item.icon} ]`}></i> {item.label}
          </Card.Body>
        </Card>
      ))}
      <Card
        key="smartBranch"
        variant="outlined"
        className={
          "branch-menu-card" +
          (activeMenu === "smartBranch" ? " active" : " inactive")
        }
        // onClick={() =>
        //   activeMenu === "smartBranch" ? null : onMenuClick("smartBranch")
        // }
        style={{
          cursor: activeMenu === "smartBranch" ? "auto" : "pointer",
          marginTop: "1em",
        }}
      >
        <Card.Body>
          <i className={`[ fas fa-user-plus ]`}></i> smartBranch
        </Card.Body>
      </Card>
    </form>
  );
}
